import { defineTracking } from 'utils/googleAnalytics/defineTracking';

const category = 'header';

export default {
    ...defineTracking({
        clickOnNotificationsIcon: {
            category,
            action: 'click on notifications icon',
            label: 'notifications bar opened',
            description: 'This event triggered when user clicks and opens the notification bar on the header.',
        },
        clickOnHamburgerIcon: {
            category,
            action: 'click on hamburger menu',
            label: 'hamburger menu bar opened',
            description: 'This event triggered when user clicks and opens on the hamburger menu.',
        },
        clickOnAccountSettingsIcon: {
            category,
            action: 'click on account settings icon',
            label: 'account setting bar opened',
            description: 'This event triggered when user clicks and opens the account settings bar on the header.',
        },
        clickOnLogo: {
            category,
            action: 'click on product logo',
            label: 'product logo clicked',
            description: 'This event triggered when user clicks on the product logo on the header.',
        },
    }),
};
